import { Competition } from 'functions/src/types/firestore/Game/Competition';
import { Leaderboards } from '../../leaderboards/Leaderboards';
import { useCallback, useEffect, useState } from 'react';
import { Game } from 'functions/src/types/firestore/Game';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { firestore } from '../../../config/firebaseClient';
import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';
import { ConverterFactory } from 'functions/src/util/firestore/ConverterFactory';

type LeaderboardsTabProps = {
  chosenLeaderboard: string;
} & Pick<Game<Date>, 'id'>;

export const LeaderboardsTab = ({
  id,
  chosenLeaderboard,
}: LeaderboardsTabProps) => {
  const [leaderboards, setLeaderboards] = useState<Competition<Date>[]>([]);
  const leaderboardsQuery = useCallback(async () => {
    const competitionsRef = query(
      collection(firestore, `Game/${id}/Competition`),
      where('type', '==', 'leaderboard'),
    ).withConverter(ConverterFactory.buildDateConverter<Competition<Date>>());
    const result = await getDocs(competitionsRef);
    const leaderboardsData = result.docs.map((doc) => doc.data());
    return leaderboardsData as Competition<Date>[];
  }, [id]);
  useEffect(() => {
    const handler = async () => {
      const leaderboardsFromQuery = await leaderboardsQuery();
      setLeaderboards(leaderboardsFromQuery);
    };
    handler();
  }, [leaderboardsQuery]);
  return (
    <Box sx={{ px: 6 }}>
      {leaderboards.length > 0 ? (
        <Leaderboards
          chosenLeaderboard={chosenLeaderboard}
          leaderboards={leaderboards}
        />
      ) : (
        <Skeleton variant="rectangular" height={800} />
      )}
    </Box>
  );
};
